<template>
    <div v-if="device.type == DeviceType.PC" class="menu">
        <div class="main" :class="{
            expended: currentMainIndex == mainIdx
        }" v-for="mainItem, mainIdx in menu" :key="mainIdx" @mouseenter="onMouseEnterMain(mainIdx, $event)"
            @mouseleave="onMouseLeaveMain(mainIdx)">
            <a :href="mainItem.link" @click="(e) => { handleItemClick(e, mainItem) }">
                <span>{{ mainItem.text }}</span>
                <svg v-if="mainItem.children != null && mainItem.children.length > 0" width="12" height="7"
                    viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0.75L6 5.25L11 0.75" stroke="currentColor" stroke-width="1.5" />
                </svg>
            </a>
            <div v-if="currentMainIndex == mainIdx && mainItem.children != null && mainItem.children.length > 0"
                class="subPanel">
                <div class="l1-list">
                    <a :href="l1Item.link" class="l1 item" :class="{ selected: currentL1Index == l1Idx }"
                        v-for="l1Item, l1Idx in mainItem.children" :key="l1Idx" @mouseenter="onMouseEnterL1(l1Idx)">
                        {{ l1Item.text }}
                    </a>
                </div>
                <template v-if="mainItem.children != null && hasSubMenu(mainItem.children[currentL1Index])">
                    <div class="l2-list" v-for="slice in getSliceCount(mainItem, currentL1Index)" :key="slice">
                        <a :href="l2Item.link" class="l2 item"
                            v-for="l2Item, l2Idx in getSliceItems(mainItem, mainItem.children[currentL1Index], slice)"
                            :key="l2Idx">
                            {{ l2Item.text }}
                        </a>
                    </div>
                </template>
            </div>
        </div>
    </div>


    <div v-if="device.type == DeviceType.MOBILE" class="menu">
        <div v-for="mainItem, mainIdx in menu" :key="mainIdx" class="main">
            <div @click="toggleExpand(mainItem)"
                :class="{ expanded: mainItem.expanded, expandable: mainItem.children != null && mainItem.children.length > 0 }">
                <a :href="mainItem.link" @click="(e) => { handleItemClick(e, mainItem) }">
                    <div>{{ mainItem.text }}</div>
                    <svg v-if="mainItem.children != null && mainItem.children.length > 0" width="12" height="7"
                        viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 0.75L6 5.25L11 0.75" stroke="currentColor" stroke-width="1.5" />
                    </svg>
                </a>
            </div>
            <div class="l1-list" v-if="mainItem.expanded">
                <div v-for="l1Item, l1Idx in mainItem.children" :key="l1Idx">
                    <div v-if="l1Item.data.type != 'url'" class="expandable" @click="toggleExpand(l1Item)"
                        :class="{ expanded: l1Item.expanded }">
                        <div>{{ l1Item.text }}</div>
                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 0.75L6 5.25L11 0.75" stroke="currentColor" stroke-width="1.5" />
                        </svg>
                    </div>
                    <div v-else class="l2-list">
                        <a :href="l1Item.link">
                            {{ l1Item.text }}
                        </a>
                    </div>
                    <div class="l2-list" v-if="l1Item.expanded">
                        <a class="summary" v-if="l1Item.data.type == 'category'" :href="l1Item.link">View All {{
                            l1Item.data.productCount }} {{ l1Item.data.title }} Tours</a>
                        <a :href="l2Item.link" v-for="l2Item, l2Idx in l1Item.children" :key="l2Idx">
                            {{ l2Item.text }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.menu {
    display: flex;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 2.2rem;
    text-align: left;
    cursor: pointer;

    .expanded {
        svg {
            transform: rotate(180deg);
            transition: 0.25s;
        }
    }

    .main {
        padding: 0.8rem 1.6rem;
        position: relative;
        font-size: 1.4rem;
        font-weight: 600;
        line-height: 7rem;

        svg {
            margin-left: 0.6rem;
            transition: 0.25s;
        }

        .subPanel {
            display: none;
            position: absolute;
            flex-wrap: wrap;
            align-items: flex-start;
            border-radius: 12px;
            background-color: white;
            padding: 1rem;
            gap: 2rem;
            box-shadow: 5px 6px 6px 0px #000000;

            .item {
                font-weight: bold;
                border-radius: 6px;
                white-space: nowrap;
                height: 4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 1rem;
                min-width: 8rem;
                justify-content: start;

                &.selected,
                &:hover {
                    background-color: rgba(76, 167, 113, 0.2);
                }
            }
        }

        &.expended {
            svg {
                transform: rotate(180deg);
                transition: 0.25s;
            }

            .subPanel {
                display: flex;
                color: black;

                .l1-list {
                    display: flex;
                    min-width: 10rem;
                    flex-direction: column;
                }

                .l2-list {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
    }
}

@media screen and (max-width:750px) {
    .menu {
        flex-direction: column;
        width: 100%;

        .expandable {
            display: flex;
            justify-content: space-between;
            align-items: center;

            a {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }

        .main {
            line-height: normal;

            .l1-list {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                padding-left: 2rem;
                padding-top: 1rem;

                .l2-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    padding-left: 2rem;
                    font-weight: normal;
                    padding-top: 1rem;

                    .summary {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>

<script setup lang="ts">
import { nextTick, onBeforeMount, onMounted, ref } from 'vue';
import Request from '@/services/Request'
import { DeviceType, useDevice } from '@/utils/DeviceUtils';
import HomeService from '@/services/HomeService';

interface MenuItem {
    text: string,
    children?: MenuItem[],
    link?: string,
    expanded?: boolean,
    data?: any
}
function handleItemClick(e, item) {
    if ((item.link == null || item.link.trim() == '') && item.data.type == 'url') {
        e.preventDefault()
    }
}
const device = useDevice()
function toggleExpand(item: MenuItem) {
    item.expanded = !item.expanded
}
function getItemTitle(item) {
    let title = item.title;
    if (item.type === 'category') {
        title += `(${item.productCount})`
    }
    return title
}

function getUrl(magaMenuItem) {
    const baseUrl = import.meta.env.BASE_URL
    let to
    if (magaMenuItem.type == 'category') {
        if (magaMenuItem.keyword != null && magaMenuItem.keyword != '') {
            if (baseUrl.endsWith("/")) {
                to = baseUrl + magaMenuItem.keyword
            }
            else {
                to = baseUrl + "/" + magaMenuItem.keyword
            }
            if (null != magaMenuItem.target) {
                to += '?' + magaMenuItem.target
            }
        }
        else {
            if (baseUrl.endsWith("/")) {
                to = baseUrl + 'search/?catId=' + magaMenuItem.categoryId
            }
            else {
                to = baseUrl + '/search/?catId=' + magaMenuItem.categoryId
            }
            if (null != magaMenuItem.target) {
                to += '&' + magaMenuItem.target
            }
        }

    }
    else if (magaMenuItem.type == 'url') {
        to = magaMenuItem.url
    }

    return to
}

function buildTreeMenu(root, childrenData) {
    if (null == childrenData || childrenData.length == 0) {
        return
    }
    const children = []
    for (const childItem of childrenData) {
        const child = {
            text: getItemTitle(childItem),
            link: getUrl(childItem),
            data: childItem,
            expanded: device.type == DeviceType.MOBILE ? false : null
        }
        buildTreeMenu(child, childItem.children)
        children.push(child)
    }
    root.children = children
}
const menu = ref<MenuItem[]>(null)

onBeforeMount(()=>{
    getmenu()
})

async function getmenu() {
    const queryParams = new URLSearchParams(window.location.search)
    let url = 'module/pavmegamenu/getMenu'
    if (queryParams.has('ad')) {
        url += '&ad=' + queryParams.get('ad')
    }
    new Request().webGet(
        {},
        (res) => {
            // const mainItems = []
            // for (const item of res.treemenu[1]) {
            //     const root = {
            //         text: getItemTitle(item),
            //         link: getUrl(item),
            //         data: item,
            //         expanded: device.type == DeviceType.MOBILE ? false : null
            //     }

            //     buildTreeMenu(root, item.megamenu_id, res.treemenu)
            //     mainItems.push(root)
            // }
            // menu.value = mainItems
        },
        url,
        (err) => { }
    )
    HomeService.menu()
        .then(data => {
            const megaMenu = data?.megaMenuModule
            if (!megaMenu || !Array.isArray(megaMenu)) {
                console.warn('MegaMenu: megaMenuModule is not available or not an array')
                return
            }
            const mainItems = []
            for (const item of megaMenu) {
                const root = {
                    text: getItemTitle(item),
                    link: getUrl(item),
                    data: item,
                    expanded: device.type == DeviceType.MOBILE ? false : null
                }
                buildTreeMenu(root, item.children)
                mainItems.push(root)
            }
            menu.value = mainItems
        })

}

function hasSubMenu(item) {
    return item != null && item.children != null && item.children.length > 0
}

const currentMainIndex = ref(null)


function onMouseLeaveMain(idx) {
    currentMainIndex.value = null
    currentL1Index.value = null
}
// Keep the sub-panel inside the viewport: when it would overflow on the right (e.g. the
// Destinations panel with 5 country columns), shift it left so its right edge fits.
function fitSubPanel(main) {
    const panel = main?.querySelector('.subPanel')
    if (!panel) return
    const margin = 8
    const maxWidth = window.innerWidth - margin * 2
    panel.style.left = '0'
    panel.style.right = 'auto'
    panel.style.maxWidth = `${maxWidth}px`
    const mainLeft = main.getBoundingClientRect().left
    const rect = panel.getBoundingClientRect()
    if (rect.right > window.innerWidth - margin) {
        // Shift the panel left so its right edge sits inside the viewport.
        const width = Math.min(rect.width, maxWidth)
        const left = Math.max(margin, window.innerWidth - margin - width)
        panel.style.left = `${left - mainLeft}px`
    }
}
function onMouseEnterMain(idx, event) {
    currentMainIndex.value = idx
    // Read currentTarget now: it is cleared once the event has been dispatched, before nextTick runs.
    const main = event?.currentTarget
    nextTick(() => fitSubPanel(main))
}

const currentL1Index = ref(null)

function onMouseEnterL1(idx) {
    currentL1Index.value = idx
}

// Items per column: up to 15, but never more than 3 columns (e.g. Europe).
const MAX_COLUMNS = 3
const MIN_ITEMS_PER_COLUMN = 15

function getSliceLength(l1Item) {
    const count = l1Item?.children?.length ?? 0
    return Math.max(MIN_ITEMS_PER_COLUMN, Math.ceil(count / MAX_COLUMNS))
}

function getSliceItems(mainItem, menu, slice) {
    const len = getSliceLength(menu)
    return menu.children.slice((slice - 1) * len, slice * len)
}

function getSliceCount(mainItem, currentL1Index) {
    const l1Item = mainItem.children[currentL1Index]
    return Math.ceil((l1Item?.children?.length ?? 0) / getSliceLength(l1Item))
}
</script>